/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ITokenRouteImport } from './routes/i/$token'
import { Route as ProjectsShareTokenRouteImport } from './routes/projects/share/$token'
import { Route as ProjectsProjectIdSettingsIndexRouteImport } from './routes/projects/$projectId/settings/index'
import { Route as ProjectsProjectIdReportsIndexRouteImport } from './routes/projects/$projectId/reports/index'
import { Route as ProjectsProjectIdRecordsIndexRouteImport } from './routes/projects/$projectId/records/index'
import { Route as ProjectsProjectIdPlansIndexRouteImport } from './routes/projects/$projectId/plans/index'
import { Route as ProjectsProjectIdIssuesIndexRouteImport } from './routes/projects/$projectId/issues/index'
import { Route as ProjectsProjectIdReportsReportIdIndexRouteImport } from './routes/projects/$projectId/reports/$reportId/index'
import { Route as ProjectsProjectIdIssuesIssueIdIndexRouteImport } from './routes/projects/$projectId/issues/$issueId/index'
import { Route as ProjectsProjectIdReportsNewPreconIndexRouteImport } from './routes/projects/$projectId_/reports/new/precon/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsShareTokenRoute = ProjectsShareTokenRouteImport.update({
  id: '/projects/share/$token',
  path: '/projects/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdSettingsIndexRoute =
  ProjectsProjectIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdReportsIndexRoute =
  ProjectsProjectIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdRecordsIndexRoute =
  ProjectsProjectIdRecordsIndexRouteImport.update({
    id: '/records/',
    path: '/records/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdPlansIndexRoute =
  ProjectsProjectIdPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdIssuesIndexRoute =
  ProjectsProjectIdIssuesIndexRouteImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdReportsReportIdIndexRoute =
  ProjectsProjectIdReportsReportIdIndexRouteImport.update({
    id: '/reports/$reportId/',
    path: '/reports/$reportId/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdIssuesIssueIdIndexRoute =
  ProjectsProjectIdIssuesIssueIdIndexRouteImport.update({
    id: '/issues/$issueId/',
    path: '/issues/$issueId/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdReportsNewPreconIndexRoute =
  ProjectsProjectIdReportsNewPreconIndexRouteImport.update({
    id: '/projects/$projectId_/reports/new/precon/',
    path: '/projects/$projectId/reports/new/precon/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/share/$token': typeof ProjectsShareTokenRoute
  '/projects/$projectId/issues/': typeof ProjectsProjectIdIssuesIndexRoute
  '/projects/$projectId/plans/': typeof ProjectsProjectIdPlansIndexRoute
  '/projects/$projectId/records/': typeof ProjectsProjectIdRecordsIndexRoute
  '/projects/$projectId/reports/': typeof ProjectsProjectIdReportsIndexRoute
  '/projects/$projectId/settings/': typeof ProjectsProjectIdSettingsIndexRoute
  '/projects/$projectId/issues/$issueId/': typeof ProjectsProjectIdIssuesIssueIdIndexRoute
  '/projects/$projectId/reports/$reportId/': typeof ProjectsProjectIdReportsReportIdIndexRoute
  '/projects/$projectId/reports/new/precon/': typeof ProjectsProjectIdReportsNewPreconIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/share/$token': typeof ProjectsShareTokenRoute
  '/projects/$projectId/issues': typeof ProjectsProjectIdIssuesIndexRoute
  '/projects/$projectId/plans': typeof ProjectsProjectIdPlansIndexRoute
  '/projects/$projectId/records': typeof ProjectsProjectIdRecordsIndexRoute
  '/projects/$projectId/reports': typeof ProjectsProjectIdReportsIndexRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsIndexRoute
  '/projects/$projectId/issues/$issueId': typeof ProjectsProjectIdIssuesIssueIdIndexRoute
  '/projects/$projectId/reports/$reportId': typeof ProjectsProjectIdReportsReportIdIndexRoute
  '/projects/$projectId/reports/new/precon': typeof ProjectsProjectIdReportsNewPreconIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/i/$token': typeof ITokenRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/share/$token': typeof ProjectsShareTokenRoute
  '/projects/$projectId/issues/': typeof ProjectsProjectIdIssuesIndexRoute
  '/projects/$projectId/plans/': typeof ProjectsProjectIdPlansIndexRoute
  '/projects/$projectId/records/': typeof ProjectsProjectIdRecordsIndexRoute
  '/projects/$projectId/reports/': typeof ProjectsProjectIdReportsIndexRoute
  '/projects/$projectId/settings/': typeof ProjectsProjectIdSettingsIndexRoute
  '/projects/$projectId/issues/$issueId/': typeof ProjectsProjectIdIssuesIssueIdIndexRoute
  '/projects/$projectId/reports/$reportId/': typeof ProjectsProjectIdReportsReportIdIndexRoute
  '/projects/$projectId_/reports/new/precon/': typeof ProjectsProjectIdReportsNewPreconIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/i/$token'
    | '/projects/$projectId'
    | '/projects/share/$token'
    | '/projects/$projectId/issues/'
    | '/projects/$projectId/plans/'
    | '/projects/$projectId/records/'
    | '/projects/$projectId/reports/'
    | '/projects/$projectId/settings/'
    | '/projects/$projectId/issues/$issueId/'
    | '/projects/$projectId/reports/$reportId/'
    | '/projects/$projectId/reports/new/precon/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/i/$token'
    | '/projects/$projectId'
    | '/projects/share/$token'
    | '/projects/$projectId/issues'
    | '/projects/$projectId/plans'
    | '/projects/$projectId/records'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/issues/$issueId'
    | '/projects/$projectId/reports/$reportId'
    | '/projects/$projectId/reports/new/precon'
  id:
    | '__root__'
    | '/'
    | '/i/$token'
    | '/projects/$projectId'
    | '/projects/share/$token'
    | '/projects/$projectId/issues/'
    | '/projects/$projectId/plans/'
    | '/projects/$projectId/records/'
    | '/projects/$projectId/reports/'
    | '/projects/$projectId/settings/'
    | '/projects/$projectId/issues/$issueId/'
    | '/projects/$projectId/reports/$reportId/'
    | '/projects/$projectId_/reports/new/precon/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ITokenRoute: typeof ITokenRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ProjectsShareTokenRoute: typeof ProjectsShareTokenRoute
  ProjectsProjectIdReportsNewPreconIndexRoute: typeof ProjectsProjectIdReportsNewPreconIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/share/$token': {
      id: '/projects/share/$token'
      path: '/projects/share/$token'
      fullPath: '/projects/share/$token'
      preLoaderRoute: typeof ProjectsShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/settings/': {
      id: '/projects/$projectId/settings/'
      path: '/settings'
      fullPath: '/projects/$projectId/settings/'
      preLoaderRoute: typeof ProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/reports/': {
      id: '/projects/$projectId/reports/'
      path: '/reports'
      fullPath: '/projects/$projectId/reports/'
      preLoaderRoute: typeof ProjectsProjectIdReportsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/records/': {
      id: '/projects/$projectId/records/'
      path: '/records'
      fullPath: '/projects/$projectId/records/'
      preLoaderRoute: typeof ProjectsProjectIdRecordsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/plans/': {
      id: '/projects/$projectId/plans/'
      path: '/plans'
      fullPath: '/projects/$projectId/plans/'
      preLoaderRoute: typeof ProjectsProjectIdPlansIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/issues/': {
      id: '/projects/$projectId/issues/'
      path: '/issues'
      fullPath: '/projects/$projectId/issues/'
      preLoaderRoute: typeof ProjectsProjectIdIssuesIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/reports/$reportId/': {
      id: '/projects/$projectId/reports/$reportId/'
      path: '/reports/$reportId'
      fullPath: '/projects/$projectId/reports/$reportId/'
      preLoaderRoute: typeof ProjectsProjectIdReportsReportIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/issues/$issueId/': {
      id: '/projects/$projectId/issues/$issueId/'
      path: '/issues/$issueId'
      fullPath: '/projects/$projectId/issues/$issueId/'
      preLoaderRoute: typeof ProjectsProjectIdIssuesIssueIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId_/reports/new/precon/': {
      id: '/projects/$projectId_/reports/new/precon/'
      path: '/projects/$projectId/reports/new/precon'
      fullPath: '/projects/$projectId/reports/new/precon/'
      preLoaderRoute: typeof ProjectsProjectIdReportsNewPreconIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdIssuesIndexRoute: typeof ProjectsProjectIdIssuesIndexRoute
  ProjectsProjectIdPlansIndexRoute: typeof ProjectsProjectIdPlansIndexRoute
  ProjectsProjectIdRecordsIndexRoute: typeof ProjectsProjectIdRecordsIndexRoute
  ProjectsProjectIdReportsIndexRoute: typeof ProjectsProjectIdReportsIndexRoute
  ProjectsProjectIdSettingsIndexRoute: typeof ProjectsProjectIdSettingsIndexRoute
  ProjectsProjectIdIssuesIssueIdIndexRoute: typeof ProjectsProjectIdIssuesIssueIdIndexRoute
  ProjectsProjectIdReportsReportIdIndexRoute: typeof ProjectsProjectIdReportsReportIdIndexRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdIssuesIndexRoute: ProjectsProjectIdIssuesIndexRoute,
  ProjectsProjectIdPlansIndexRoute: ProjectsProjectIdPlansIndexRoute,
  ProjectsProjectIdRecordsIndexRoute: ProjectsProjectIdRecordsIndexRoute,
  ProjectsProjectIdReportsIndexRoute: ProjectsProjectIdReportsIndexRoute,
  ProjectsProjectIdSettingsIndexRoute: ProjectsProjectIdSettingsIndexRoute,
  ProjectsProjectIdIssuesIssueIdIndexRoute:
    ProjectsProjectIdIssuesIssueIdIndexRoute,
  ProjectsProjectIdReportsReportIdIndexRoute:
    ProjectsProjectIdReportsReportIdIndexRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ITokenRoute: ITokenRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ProjectsShareTokenRoute: ProjectsShareTokenRoute,
  ProjectsProjectIdReportsNewPreconIndexRoute:
    ProjectsProjectIdReportsNewPreconIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
